<template>
  <div>
    <div class="ant-descriptions-title">
      Thông tin tài khoản
    </div>
    <a-skeleton :loading="loadingItem" :paragraph="{ rows: 6 }">
      <a-descriptions :column="1">
        <a-descriptions-item label="Tên tài khoản"> </a-descriptions-item>
        <a-descriptions-item label="Email"> </a-descriptions-item>
      </a-descriptions>
    </a-skeleton>
    <a
      ><i> <a-icon type="setting" /> Đổi mật khẩu tài khoản</i>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    user: {
      type: Object,
    },
    loadingItem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
